export default "__VITE_ASSET__7e78eec6__"